import { FC, useCallback, useState } from 'react';
import { Accordion } from 'react-bootstrap';

import { ChildrenPropType } from 'src/utils/types';
import { CommonIconProps } from 'src/components/Icons/commonIconProps';
import { ItemAccordionToggle } from '../Item';

type Props = {
  children: ChildrenPropType;
  title: string;
  icon: FC<CommonIconProps>;

  collapsed?: boolean;
  defaultOpened?: boolean;
  testId?: string;
};

export const GroupExtended: FC<Props> = ({ title, icon, children, defaultOpened, collapsed, testId }) => {
  const DEFAULT_ACTIVE_KEY = '0';
  const COLLAPSED_ACTIVE_KEY = '1';

  const [currentEventKey, setCurrentEventKey] = useState<string | undefined>(
    defaultOpened ? DEFAULT_ACTIVE_KEY : undefined
  );

  const handleSelect = useCallback((key: string | null) => {
    setCurrentEventKey(key || undefined);
  }, []);

  return (
    <Accordion activeKey={collapsed ? COLLAPSED_ACTIVE_KEY : currentEventKey} onSelect={handleSelect}>
      <ItemAccordionToggle eventKey={DEFAULT_ACTIVE_KEY} title={title} icon={icon} testId={testId} />

      <Accordion.Collapse eventKey={DEFAULT_ACTIVE_KEY}>
        <>{children}</>
      </Accordion.Collapse>
    </Accordion>
  );
};
